import _default from './Collection';
export { _default as default };
import _Collection from './Collection';
export { _Collection as Collection };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/Collection/index.js
// module id = 2101
// module chunks = 0